<span *ngIf="environments" ngbDropdown="ngbDropdown">
  <button
    class="btn btn-sm"
    ngbDropdownToggle="ngbDropdownToggle"
    type="button"
  >
    <span>{{ selectedEnvironmentName() }}</span>
  </button>
  <ul class="dropdown-menu--reduced-padding" ngbDropdownMenu="ngbDropdownMenu">
    <li *ngIf="showAllEnvironmentsOption()">
      <a
        (click)="changeEnvironment('all', true)"
        ngbDropdownItem="ngbDropdownItem"
        ><i class="list-icon glyphicon"></i>All environments</a
      >
    </li>
    <li *ngFor="let env of environments; trackBy: trackByIndex">
      <a
        (click)="changeEnvironment(env, true)"
        ngbDropdownItem="ngbDropdownItem"
        ><i
          class="list-icon glyphicon"
          [ngClass]="{ 'glyphicon-check': env === environment }"
        ></i
        >{{ env || "Unknown environment" }}</a
      >
    </li>
  </ul></span
>
